// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#004acf","menuText":"#fff","menuActiveText":"#fff"};